import { render, staticRenderFns } from "./ListaCashbackPorPaciente.vue?vue&type=template&id=41833fa3"
import script from "./ListaCashbackPorPaciente.vue?vue&type=script&lang=js"
export * from "./ListaCashbackPorPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports